import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { appStore } from './redux-state';
import App from './custom/components/app';
/*
 * We're using the custom app component here. It is intentional. Patrick discussed this with Yuto. 
 * If there is an update to the calendar in the future this line will need to be corrected
 */


render(
    <Provider store={appStore}>
        <App />
    </Provider>
    , document.getElementById("calendar-entry-js"));